export enum SyncJobType {
  AccountingCustomers = 0,
  AccountingProducts = 50,
  AccountingSales = 100,
}
